import { render, staticRenderFns } from "./ColdKnowlegeCard.vue?vue&type=template&id=004b205e"
import script from "./ColdKnowlegeCard.vue?vue&type=script&lang=ts"
export * from "./ColdKnowlegeCard.vue?vue&type=script&lang=ts"
import style0 from "./ColdKnowlegeCard.vue?vue&type=style&index=0&id=004b205e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports